// §18.1 shared picker: AccountPicker. A styled native <select> — keyboard-navigable and
// type-ahead searchable for free via the browser. "Recent-first" ordering needs usage
// tracking that doesn't exist yet, so this orders by displayOrder (AC-2) for now.
import type { CurrencyCode } from '@pfos/engine';
import { useAccounts } from '../lib/accounts';
import { selectClass } from './FormKit';

export function AccountPicker({
  id,
  value,
  onChange,
  currencyFilter,
}: {
  id: string;
  value: string;
  onChange: (accountId: string) => void;
  /** Only offer accounts in this currency — a transaction can't cross currencies. */
  currencyFilter?: CurrencyCode;
}): React.JSX.Element {
  const { data: accounts } = useAccounts();
  const options = (accounts ?? [])
    .filter((a) => !a.archived)
    .filter((a) => currencyFilter === undefined || a.currency === currencyFilter)
    .sort((a, b) => a.displayOrder - b.displayOrder);

  return (
    <select
      id={id}
      className={selectClass}
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
      }}
    >
      <option value="" disabled>
        Select an account
      </option>
      {options.map((a) => (
        <option key={a.id} value={a.id}>
          {a.name} ({a.currency})
        </option>
      ))}
    </select>
  );
}
